module.exports = __webpack_public_path__ + "img/word.ee4f5cb2.png";